import { styled } from '@mui/material/styles'

export const Content = styled('div')`
  min-width: ${({ theme }) => theme.spacing(40)};
`
